import { CircularProgress } from '@mui/material';
import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { getMunicipalityByLocality } from '../api';
import ActionBoxBrown from '../components/ActionBoxBrown';
import ActionBoxCoupon from '../components/ActionBoxCoupon';
import ActionBoxOthers from '../components/ActionBoxOthers';
import ActionBoxPlastic from '../components/ActionBoxPlastic';
import ActionBoxRow from '../components/ActionBoxRow';
import ActionBoxRowRound from '../components/ActionBoxRowRound';
import { useModal } from '../contexts/ModalContext';
import useAuth from '../hooks/useAuth';
import useMunicipality from '../hooks/useMunicipality';
import NotFind from './NotFind';
import { useNavigate } from 'react-router-dom';

const Action = () => {
  const { setModal, unSetModal } = useModal()

  const { municipality } = useMunicipality();

  const { login, user, isAuthenticated } = useAuth();

   const navigate = useNavigate();
      useEffect(() => {
          if (municipality.IsGreenSchool === 1 && municipality.MunicipalityId !== 5) {
              // alert('Redirecting to ' + municipality.LocalityEn);
              navigate('/' + municipality.LocalityEn);
          }
      }, [municipality, navigate]);


  const { isLoading, isError, error, data: currentMunicipality, isFetching, } =
    useQuery(['selected_municipality', municipality],
      () =>
        getMunicipalityByLocality(municipality.LocalityEn),
      {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        // /keepPreviousData: true
      })



  if (isLoading || isFetching)
    return <div
      className='flex justify-center items-center h-screen'><CircularProgress></CircularProgress></div>

  if (isError) {

    return <div
      className='flex p-8 justify-center h-screen items-center'>
      <div className=' text-center'>

        <p className='texgt-md font-medium'>ERROR LOADING DATA: {error.message} </p>
      </div>
    </div>
  }

  if (currentMunicipality === 'NO_MUNICIPALITY')
    return <NotFind></NotFind>


  //console.log(currentMunicipality)

  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-2xl px-4 py-8 mx-auto sm:py-10 sm:px-6 lg:max-w-7xl lg:px-8">
        <h2 className="text-3xl font-bold text-gray-700 ">Ανακύκλωσε και κέρδισε πόντους!</h2>
        {municipality.MunicipalityId === 380
          ? <h2 className="text-lg font-normal text-gray-700 pb-1">Επίλεξε το Πρόγραμμα Διαλογής στην Πηγή που συμμετέχεις και κέρδισε πόντους.</h2>
          : <h2 className="text-lg font-normal text-gray-700 pb-7">Δήλωσε τις ενέργειές σου και κέρδισε πόντους.</h2>
        }
        {municipality.MunicipalityId === 380
          ?
          <h2 className="font-normal text-gray-700 pb-7">Συμμετέχοντας ενεργά στα Προγράμματα Διαλογής στην Πηγή του Δήμου κερδίζεις 200 πόντους ανά μήνα με βάση την ανακύκλωση που πραγματοποιείς. Επίλεξε το πρόγραµµα που συμμετέχεις, ακολούθησε τη διαδικασία καταχώρησης κωδικού ετικέτας και κάθε μήνα ύστερα από έλεγχο των στοιχείων ανακύκλωσης Θα προστίθενται στο λογαριασμό σου οι πόντοι επιβράβευσης.</h2>
          : null}


        {municipality.MunicipalityId === 380 ?
          <div
            className='container flex flex-col mb-12 space-y-12'>
            <ActionBoxBrown
              title={'Έχω κάφε κάδο'}
              subtitle={'Καταχώρησε τον αριθμό ετικέτας και κέρδισε πόντους.'}
              icon={'../assets/images/binicon.png'}
              points={25}
              type={'Ανακύκλωσης'}
              img={'https://followgreen.fra1.digitaloceanspaces.com/Content/css/assets/brownbins.png'}
              bottomTytle={'Ανακύκλωση Υπολειμμάτων τροφών'}
              buttonTitle={'Καταχώρηση'}
            />
            <ActionBoxPlastic
              title={'Χρησιμοποιώ έξυπνες αυτοκόλλητες ετικέτες'}
              subtitle={'Καταχώρησε τον αριθμό ετικέτας και κέρδισε πόντους.'}
              icon={'../assets/images/bag.png'}
              points={25}
              type={'Ανακύκλωσης'}
              img={'https://followgreen.fra1.digitaloceanspaces.com/Content/css/assets/bags.png'}
              bottomTytle={'ανακύκλωση Χαρτιού, Pet, PmD με χρήση σακουλών'}
              buttonTitle={'Καταχώρηση'}
            />
          </div>
          : null
        }


        <ActionBoxCoupon
          supportsSaving={currentMunicipality.SupportsSaving === 1 ? true : false}
        />





        <ActionBoxRow

          hasYellowBucket={currentMunicipality.SupportYellowBucket === 1 ? true : false}
          hasOrganicBucket={currentMunicipality.SupportOrganicBucket === 1 ? true : false}

        />


        <ActionBoxRowRound

          supportsSaving={currentMunicipality.SupportsSaving === 1 ? true : false}
          supportsDonation={currentMunicipality.SupportsDonation === 1 ? true : false}
        />





      </div>
    </div>
  )
}

export default Action